/**
 * Decimal item
 * @param {*} editor
 */
function decimal(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `0.\\overline{${text}}`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'decimal',
    action: decimal,
    className: 'decimalicon',
    title: 'Decimal infinito',
  };

  return option;
}
